import { useEffect, useState } from 'react'

import useDebounce from './useDebounce'
import PropTypes from 'prop-types'

const useWindowScroll = (delay = 300) => {
  const [state, setState] = useState({
    x: 0,
    y: 0,
  })

  const debouncedState = useDebounce(state, delay)

  useEffect(() => {
    const handleScroll = () => {
      const { scrollX = 0, scrollY = 0 } = window
      setState({ x: scrollX, y: scrollY })
    }

    handleScroll()
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return debouncedState
}

export default useWindowScroll

useWindowScroll.propTypes = {
  delay: PropTypes.number,
}
